import { render } from "./SearchShooper.vue?vue&type=template&id=260f3809"
import script from "./SearchShooper.vue?vue&type=script&lang=js"
export * from "./SearchShooper.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sendi\\.tools\\sources\\SendiNewClient2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__